export const SportList = [
    {
        id:1,
        title:"Winners of CBSE Cluster 2025",
        folderTitle:"/sport/cluster2025/",
        images:["1.jpg","2.jpg","3.jpeg","4.jpeg","5.jpg","6.jpg","7.jpg","8.jpeg","9.jpeg","10.jpg","11.jpg","12.jpg","13.jpg","14.jpg"]
    },
     {
        id:2,
        title:"Winners of Khelo Mahakumbh 2025-26",
        folderTitle:"/sport/mahakumbh2025-26/",
        images:["1.jpeg","2.jpeg","3.jpg","4.jpg","5.jpg","6.jpg","7.jpg","8.jpg","9.jpg","10.jpg"]
    },
    {
        id:3,
        title:"Mukhyamantri Udeeyman Khiladi Unnayan Chhatravriti Yojana",
        folderTitle:"/sport/scholarship/",
        images:["2022.jpg","2023.jpg","2024.jpg","2025.jpg"]
    },
     {
        id:4,
        title:"Winners of Khelo Mahakhumbh 2024-25",
        folderTitle:"/sport/mahakumbh2024-25/",
        images:["1.jpg","2.jpg","3.jpg"]
    },
       {
        id:5,
        title:"International Yoga Day 2025",
        folderTitle:"/sport/yoga2025/",
        images:["5.jpg","2.jpg","9.jpg","4.jpg","1.jpg","3.jpg","7.jpg","8.jpg","6.jpg","10.jpg","11.jpg"]
    },
    
       {
        id:6,
        title:"Intra Class Cricket Match 2025",
        folderTitle:"/sport/cricket2025/",
        images:["5.jpg","2.jpg","9.jpg","4.jpg","1.jpg","3.jpg","7.jpg","8.jpg","6.jpg","10.jpg","11.jpg"]
    },
    
       {
        id:7,
        title:"Fun Activities 2025",
        folderTitle:"/sport/funactivites2025/",
        images:["4.jpg","2.jpg","1.jpg","5.jpg","3.jpg","7.jpg","8.jpg","6.jpg","10.jpg",
            "11.jpg","12.jpg","13.jpg","14.jpg","15.jpg","16.jpg","17.jpg","18.jpg","19.jpg","20.jpg",
            "21.jpg","22.jpg","24.jpg","25.jpg","26.jpg","27.jpg"
        ]
    },
    
   
]